import Component from "vue-class-component";
import Vue from "vue";
import { MAudio } from "@/utils/audio";
import { judgeDeviceType } from "@/utils/device";
/**components**/
@Component({
  props:{
    activityType:{
      type: String,
      default: ''
    },
    infoDetail:{
      type: Object,
      default: {}
    },
    cardType:{
      type: String,
      default: ''
    },
    isLastWeek:{
      type: Boolean,
      default: false
    }
  },
  filters:{
    // 金额处理 分转化为元
    formatMoney(num) {
      return (num / 100).toFixed(2);
    }
  }
})
export default class vipCard extends Vue {
  self: Vue = this;
  isPlaying: Boolean = false;
  playState:String = "initial"; // initial 初始态，没有播放   playing 正在播放    paused 暂停中
  isShow: boolean = false; // 是否显示
  audiobox = null;

  playIcon = require("/public/images/welfare/vipdays/triangle@2x.png");
  favouriteIcon = require("/public/images/welfare/vipdays/favourite.svg");
  noFavouriteIcon = require("/public/images/welfare/vipdays/no-favourite.svg");
  tagAi = require("/public/images/welfare/vipdays/tag-ai.png");
  tagHot = require("/public/images/welfare/vipdays/hot-tag.png");
  sale = require("/public/images/welfare/vipdays/sale.png");
  saleOut = require("/public/images/welfare/vipdays/sale-out.png");
  buyImg = require("/public/images/welfare/vipdays/buy.png");
  tabMap = {
    '会员': "vip",
    '声音包': "voice",
    '充电包': "aiText",
  };
  priceUnitObj={
    'month': '个月',
    'day': '天',
    'year': '年',
  }

  created(moduleData: IinjectDatas) {
    // this.audiobox = MAudio.listen({
    //   playing: () => {
    //     this.playState = "playing";
    //   },
    //   pause: () => {
    //     this.playState = "paused";
    //   },
    //   ended: () => {
    //     this.playState = "initial";
    //   },
    // });
  }
  mounted(moduleData: IinjectDatas) {
    this.isShow = !judgeDeviceType.isIOSWxMini
  }
  
  get getVipIcon(){
    const mapping = {
      '会员': '1',
      '充电包': '3',
    };
    return mapping[this.$props.infoDetail.tabName] || '';
  }
  get numColor(){
    const infoDetail = this.$props.infoDetail
    // 销量小于100红色，小于200黄色，大于200绿色
    return infoDetail.quantity<100?'#FE5050':(infoDetail.quantity<200?'#FF7C12':'#00AA81')
  }
  // 播放音频
  playAudio() {
    if (!this.isPlaying) {
      this.$nextTick(() => {
        this.audiobox.setSrc(this.$props.infoDetail.demoUrl);
        this.audiobox.play()
        this.isPlaying = true
      })
    } else {
      this.pauseAudio()
    }
  }
  get voiceDetailUnit(){
    if(this.$props.infoDetail&&this.$props.infoDetail.priceUnit){
      return this.$props.infoDetail.priceDuration + this.priceUnitObj[this.$props.infoDetail.priceUnit]
    }else{
      return ''

    }
  }
  pauseAudio() {
    this.audiobox.pause()
    this.isPlaying = false
  }
  isJump = false
  jump(item) {
    if(this.isJump) return
    this.isJump = true
    setTimeout(()=>{
      this.isJump = false
    },1000)

    if(item.quantity<=0||this.$props.isLastWeek) return
    let par = {
      skuId: item.id,
      skuType: item.tabName
    }
    if(judgeDeviceType.isAPP){
      let memberDayPageInfo: any = (<any>window).memberDayPageInfo
			memberDayPageInfo.postMessage(JSON.stringify(par))
      // App跳转支付
    }else{
      if(judgeDeviceType.isIOSWxMini) return
      //跳转到小程序的详情页
      par['activityType'] = 'VIP_DAY'
      this.$navigateTo({
        url: `/mine-package/pages/payment/payment?item=${JSON.stringify(par)}`
      });
    }
	
	}
}
